import { createAction, props } from '@ngrx/store';
import { User, userMenuAccess } from './auth.model';

export const login = createAction(
  '[Auth] Login',
  props<{ email: string; password: string }>()
);

export const loginSuccess = createAction(
  '[Auth] Login Success',
  props<{ user: User; token: string }>()
);

export const loginFailure = createAction(
  '[Auth] Login Failure',
  props<{ error: string }>()
);

export const logout = createAction('[Auth] Logout');

export const loadAuthDataFromLocalStorage = createAction(
  '[Auth] Load Auth Data From LocalStorage',
  props<{ user: any; token: string,permissions: userMenuAccess }>()
);

export const setPermissionsRole = createAction(
  '[Auth] Set Permissions',
  props<{ permissions: userMenuAccess }>()
);

